<form [formGroup]="additionalInformationFormGroup">
  <fieldset class="border rounded-3 p-3">
    <legend class="subtitle-4 float-none w-auto px-3">
      Component Information
    </legend>
    <div class="container">
      <div
        class="result mb-5"
        *ngIf="[6].indexOf(component_mawp.strD_iclass) !== -1"
      >
        <p [innerHTML]="MAWP_result"></p>
      </div>
    </div>
  </fieldset>
  <fieldset
    class="border rounded-3 p-3"
    *ngIf="[6].indexOf(component_mawp.strD_iclass) !== -1"
  >
    <legend class="subtitle-4 float-none w-auto px-3">
      Weld and Material Information
    </legend>
    <div class="container">
      <validation
        [ValidationList]="validation_list_ComponentInformation"
        [ValidationLabel]="basicValidationLabel"
      ></validation>
      <component-information
        (comboBox2_DI_EnabledEvent)="comboBox2_DI_Enabling($event)"
        (textBox4_DI_EnabledEvent)="textBox4_DI_Enabling($event)"
        [comboBox1_DI_Disable]="comboBox1_DI_Disable"
        [componentData]="componentData"
        [checkValidation]="componentInformationValidation"
      ></component-information>
    </div>
  </fieldset>
</form>
